import { Box, Typography, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Iconify from '../iconify';
import FileThumbnail from '../file-thumbnail';

FileAttachment.propTypes = {
  handleClickAttachment: PropTypes.func, // onClick handler can be undefined
  file: PropTypes.object,
  fileName: PropTypes.string,
  canDeleteFile: PropTypes.bool,
  handleDeleteFile: PropTypes.func,
  backgroundColor: PropTypes.string,
  compact: PropTypes.bool,
}
export default function FileAttachment({
  handleClickAttachment,
  file,
  fileName,
  canDeleteFile,
  backgroundColor = "rgba(193, 201, 208, 0.2)",
  compact = false,
  handleDeleteFile = () => {},
}) {
  
  const textRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkTooltip = () => {
      if (textRef.current) {
        setShowTooltip(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };
    checkTooltip();
    window.addEventListener('resize', checkTooltip);
    return () => window.removeEventListener('resize', checkTooltip);
  }, []);

  return <Box
    sx={{
      display:'flex',
      borderRadius: '5px',
      alignItems: 'center',
      backgroundColor,
      my: compact ? 0.2 : 0.3,
      mx: 0,
      px: compact ? 0.35 : 0.5,
      py: compact ? 0.35 : 0.5,
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      boxSizing: 'border-box',
      overflow: 'hidden',
      cursor: handleClickAttachment ? 'pointer' : 'default',
    }}
    onClick={handleClickAttachment}
    key={fileName}>
    <FileThumbnail
      file={file}
      tooltip
      sx={{ width: compact ? 20 : 25, height: compact ? 20 : 25 }}
    />
    <Box sx={{ flex: 1, minWidth: 0, maxWidth: '100%' }}>
      <Tooltip title={showTooltip ? fileName : ''} placement='top'>
        <Typography
          ref={textRef}
          sx={{
            px: 1,
            color: (theme) => theme.palette.grey[700],
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }}
          variant={compact ? 'caption' : 'body2'}
        >
          {fileName}
        </Typography>
      </Tooltip>
    </Box>
    {canDeleteFile &&
    <Iconify
      icon="mdi:close"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleDeleteFile();
      }}
      sx={{ml: 'auto', mr: 0}}
    />}
  </Box>
}